import { DASHBOARD_ACCESS } from "@/helpers/superAdminPermissionConstant";

export default [
    {
      path: "/super-admin-dashboard",
      name: "super-admin-dashboard",
      component: () => import("@/views/super-admin/dashboard/SuperAdminDashboardView.vue"),
      meta: {
        gate: DASHBOARD_ACCESS,
        pageTitle: "Super Admin Dashboard",
        requiresSuperAdmin: true,
        layout: "super-admin",
      },
    },
  ];
  